import {
  EmployeeRole,
  EmployerStaffRole,
  PeoPayrollProviderStaffRole,
  PeoStaffRole,
  PlatformStaffRole,
  VerifierStaffRole,
} from 'src/api';

export enum UserPermissionKey {
  isPlatformAdmin = 'isPlatformAdmin',
  isPlatformManager = 'isPlatformManager',
  isEmployerAdmin = 'isEmployerAdmin',
  isEmployerManager = 'isEmployerManager',
  isVerifierAdmin = 'isVerifierAdmin',
  isVerifierManager = 'isVerifierManager',
  isEmployee = 'isEmployee',
  isPeoManager = 'isPeoManager',
  isPeoAdmin = 'isPeoAdmin',
  isPeoSuperAdmin = 'isPeoSuperAdmin',
  isPeoPayrollProviderUser = 'isPeoPayrollProviderUser',
  hasPlatformRoles = 'hasPlatformRoles',
  hasEmployerRoles = 'hasEmployerRoles',
  hasVerifierRoles = 'hasVerifierRoles',
  hasPeoRoles = 'hasPeoRoles',
}

export type UserPermissions = {
  [UserPermissionKey.isPlatformAdmin]: boolean;
  [UserPermissionKey.isPlatformManager]: boolean;
  [UserPermissionKey.isEmployerAdmin]: boolean;
  [UserPermissionKey.isEmployerManager]: boolean;
  [UserPermissionKey.isVerifierAdmin]: boolean;
  [UserPermissionKey.isVerifierManager]: boolean;
  [UserPermissionKey.isEmployee]: boolean;
  [UserPermissionKey.isPeoManager]: boolean;
  [UserPermissionKey.isPeoAdmin]: boolean;
  [UserPermissionKey.isPeoSuperAdmin]: boolean;
  [UserPermissionKey.isPeoPayrollProviderUser]: boolean;
  [UserPermissionKey.hasPlatformRoles]: boolean;
  [UserPermissionKey.hasEmployerRoles]: boolean;
  [UserPermissionKey.hasVerifierRoles]: boolean;
  [UserPermissionKey.hasPeoRoles]: boolean;
};

export const BusinessRole = {
  ...EmployerStaffRole,
  ...VerifierStaffRole,
  ...PlatformStaffRole,
  ...EmployeeRole,
  ...PeoStaffRole,
  ...PeoPayrollProviderStaffRole,
};
export type BusinessRole = (typeof BusinessRole)[keyof typeof BusinessRole];

export const BusinessRolesObject: Record<UserPermissionKey, BusinessRole[]> = {
  [UserPermissionKey.isPlatformAdmin]: [BusinessRole.PlatformAdmin],
  [UserPermissionKey.isPlatformManager]: [BusinessRole.PlatformManager],
  [UserPermissionKey.isEmployerAdmin]: [BusinessRole.EmployerAdmin],
  [UserPermissionKey.isEmployerManager]: [BusinessRole.EmployerManager],
  [UserPermissionKey.isVerifierAdmin]: [BusinessRole.VerifierAdmin],
  [UserPermissionKey.isVerifierManager]: [BusinessRole.VerifierManager],
  [UserPermissionKey.isEmployee]: [BusinessRole.Employee],
  [UserPermissionKey.isPeoManager]: [BusinessRole.PeoManager],
  [UserPermissionKey.isPeoAdmin]: [BusinessRole.PeoAdmin],
  [UserPermissionKey.isPeoSuperAdmin]: [BusinessRole.PeoSuperAdmin],
  [UserPermissionKey.isPeoPayrollProviderUser]: [BusinessRole.PeoPayrollProviderUser],
  [UserPermissionKey.hasPlatformRoles]: [BusinessRole.PlatformAdmin, BusinessRole.PlatformManager],
  [UserPermissionKey.hasEmployerRoles]: [BusinessRole.EmployerAdmin, BusinessRole.EmployerManager],
  [UserPermissionKey.hasVerifierRoles]: [BusinessRole.VerifierAdmin, BusinessRole.VerifierManager],
  [UserPermissionKey.hasPeoRoles]: [
    BusinessRole.PeoSuperAdmin,
    BusinessRole.PeoAdmin,
    BusinessRole.PeoManager,
  ],
};
